import React, { ReactElement } from 'react'
import {
  ListPrefix,
  ListGroupWrapper,
  CardItem,
  CardWrapper,
  Chevron,
  CardTitle
} from './subcomponents'
import { Card } from 'react-bootstrap'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

interface Listprops {
  id?: string
  title: string
  index: number
  icon?: ReactElement
  subTitle?: string
  onSelect?: () => void
  children?: ReactElement
  isSelected?: boolean
  isMobileMenuOpen?: boolean
}

const ListItem = ({
  id = 'list',
  icon,
  title,
  index,
  subTitle,
  onSelect,
  children,
  isSelected,
  isMobileMenuOpen
}: Listprops): ReactElement => {
  const prefix = icon || index + 1
  const chevronIcon: IconProp = children
    ? isSelected
      ? ['fas', 'chevron-up']
      : ['fas', 'chevron-down']
    : ['fas', 'chevron-right']

  return (
    <ListGroupWrapper id={id} isMobileMenuOpen={isMobileMenuOpen}>
      <CardItem onClick={onSelect} role="button" tabIndex="0">
        <ListPrefix>{prefix}</ListPrefix>
        <CardWrapper>
          <CardTitle>{title}</CardTitle>
          {subTitle && (
            <Card.Subtitle className="mb-2 text-muted">
              {subTitle}
            </Card.Subtitle>
          )}
        </CardWrapper>
        {onSelect && <Chevron icon={chevronIcon} size="lg" />}
      </CardItem>
      {isSelected && children}
    </ListGroupWrapper>
  )
}

export default ListItem
